import React from 'react';
import propTypes from 'prop-types';
import { connect } from 'react-redux';
import {
	Text,
	Box,
	PrimaryButton,
	SmartLink,
	CheckmarkIllustration,
	Tile,
	ListView,
	Layout,
} from '@stashinvest/ui';
import { selectAccounts } from 'stash/selectors';
import { trackEvent } from 'stash/actions';
import { flushSignUp } from 'stash/actions';
import { dashboardNotReady } from '../../../actions/dashboard';
import { postBuyWithDeposit } from '../../../actions/api/transactions';
import { postAccountAutoStash } from '../../../actions/api/autoStash';
import { clearAction } from '../../../actions/deferredActions';
import { isEmpty } from 'stash/utils/helpers';
import AccountIcon from '../../icons/AccountIcon';
import AutoStashIcon from '../../icons/AutoStashIcon';
import BuyVerification from 'stash/components/buy/BuyVerification';
import { SignUpStep } from '../SignUpScreenLayout';

const mapStateToProps = (state, ownProps) => ({
	name: state.entities.user.first_name,
	bankAccount: state.entities.bank_account,
	accounts: selectAccounts(state),
	accountId:
		state.entities.account_by_type.ROTH_IRA ||
		state.entities.account_by_type.TRADITIONAL_IRA,
	deferredActions: state.application.deferredActions,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	trackRetireCompleteAddOn: () => {
		dispatch(
			trackEvent('RetireAddOn', {
				ScreenName: 'SuccessValueProp',
			})
		);
	},
	trackRetireCompleteAddOnAction: (linkTo) => {
		dispatch(
			trackEvent('RetireAddOn', {
				ScreenName: 'SuccessValueProp',
				Action: linkTo,
			})
		);
	},
	postBuy: (accountId, cardId, amount) => {
		return dispatch(postBuyWithDeposit(accountId, cardId, amount));
	},
	postAutoStash: (accountId, auto_stash) => {
		return dispatch(postAccountAutoStash(accountId, { auto_stash }));
	},
	clearAction: (key) => {
		return dispatch(clearAction(key));
	},
	flushData: () => {
		return dispatch(flushSignUp());
	},
	resetDashboardReady: () => {
		return dispatch(dashboardNotReady());
	},
});

class SignUpRetireCompleteAddOn extends React.Component {
	componentDidMount() {
		const {
			accountId,
			bankAccount,
			deferredActions,
			clearAction,
			postBuy,
			postAutoStash,
			resetDashboardReady,
			trackRetireCompleteAddOn,
		} = this.props;

		const hasBankAccount = !isEmpty(bankAccount);

		// reset the dashboard ready flag so all account data gets loaded
		resetDashboardReady();

		// Check if any deferred actions need to be sent
		const buyOptions = deferredActions['addOnRetireBuy'];
		const autoStash = deferredActions['addOnRetireAutoStash'];

		// buys only work with a linked bank account
		hasBankAccount &&
			buyOptions &&
			postBuy(
				accountId,
				buyOptions.cardId,
				buyOptions.initialContribution
			).then((res) => clearAction('addOnRetireBuy'));

		autoStash &&
			postAutoStash(accountId, autoStash).then((res) =>
				clearAction('addOnRetireAutoStash')
			);

		trackRetireCompleteAddOn();
	}

	componentWillUnmount() {
		this.props.flushData();
	}

	render() {
		const { name, accountId, trackRetireCompleteAddOnAction } = this.props;

		return (
			<Layout.PageWrap height="100vh" mt="0">
				<BuyVerification />
				<SignUpStep>
					<Box maxWidth="28rem" mx="auto">
						<CheckmarkIllustration mb="s24" />
						<Text.H1 size="3" mb="xxs">
							It’s official, {name}!
						</Text.H1>
						<Box mb="s">
							<Text mb="m">
								Your golden years are looking money. Now, go take a nap. What do
								you want to do next?
							</Text>
							<Tile p="0">
								<ListView
									img={<AccountIcon accountType="PERSONAL_BROKERAGE" />}
									variant={2}
									p="m"
									title={<Text.H5 ml="xs">View investments</Text.H5>}
									onClick={() =>
										trackRetireCompleteAddOnAction('ViewInvestments')
									}
									to="/investments"
								/>
							</Tile>
							<Tile p="0">
								<ListView
									img={<AutoStashIcon width="1rem" alt="Autostash" />}
									variant={2}
									p="m"
									title={<Text.H5 ml="xs">Update Auto-Stash</Text.H5>}
									onClick={() =>
										trackRetireCompleteAddOnAction('ViewAutoStash')
									}
									to={`/auto-stash/set-schedule?account_id=${accountId}`}
								/>
							</Tile>
						</Box>
						<PrimaryButton
							as={SmartLink}
							onClick={() => trackRetireCompleteAddOnAction('ViewAccount')}
							to={`/portfolio?account_id=${accountId}`}
						>
							Take me to my account
						</PrimaryButton>
					</Box>
				</SignUpStep>
			</Layout.PageWrap>
		);
	}
}

SignUpRetireCompleteAddOn.propTypes = {
	accounts: propTypes.object,
	accountId: propTypes.string,
	bankAccount: propTypes.object,
	deferredActions: propTypes.object,
	clearAction: propTypes.func,
	onSubmit: propTypes.func,
	postBuy: propTypes.func,
	postAutoStash: propTypes.func,
	resetDashboardReady: propTypes.func,
	trackRetireCompleteAddOn: propTypes.func,
	trackRetireCompleteAddOnAction: propTypes.func,
	name: propTypes.string,
	agreements: propTypes.oneOfType([propTypes.array, propTypes.object]),
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(SignUpRetireCompleteAddOn);
